import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import App from './App';
import './assets/styles/index.scss';

import VueMask from 'v-mask'
Vue.use(VueMask);

Vue.config.productionTip = false;

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: 'history',
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

window.Router = router;

new Vue({
  render: h => h(App),
  router,
}).$mount('#app');
